import React from "react";
import { Link } from "react-router-dom";
import instagramIcon from "@public/img/instagram.svg";
import telegramIcon from "@public/img/telegram.svg";
import copyrightIcon from "@public/img/copyright.svg";
import NavItem from "./commom/nav-item";
import infoSquareIcon from "@public/img/info-square.svg";
import userWavesIcon from "@public/img/user-waves.svg";
import gridIcon from "@public/img/grid.svg";
import homeIcon from "@public/img/home.svg";
import MobileMenu from "./parts/mobile-menu";
import "@/styles/footer.css";

export default function Footer() {
    return (
        <>
        <footer className="site-footer">
            <div className="site-footer__inner container mx-auto px-5 lg:px-0">
                <div className="site-footer__top">
                    <span className="site-footer__logo">WONMOV</span>

                    <nav className="site-footer__nav">
                        <NavItem label="صفحه اصلی" icon={homeIcon} href="/" inFooter />
                        <NavItem label="دسته بندی" icon={gridIcon} href="/movies" inFooter />
                        <NavItem label="بازیگران" icon={userWavesIcon} href="/actors" inFooter />
                        <NavItem label="درباره ما" icon={infoSquareIcon} href="/about" inFooter />
                    </nav>

                    <div className="site-footer__social">
                        <Link
                            to="https://instagram.com"
                            target="_blank"
                            aria-label="اینستاگرام"
                            className="site-footer__social-link"
                        >
                            <img src={instagramIcon} alt="" />
                        </Link>
                        <Link
                            to="https://telegram.org"
                            target="_blank"
                            aria-label="تلگرام"
                            className="site-footer__social-link"
                        >
                            <img src={telegramIcon} alt="" />
                        </Link>
                    </div>
                </div>

                <div className="site-footer__copyright">
                    <img src={copyrightIcon} alt="" />
                    <span>کلیه حقوق مادی و معنوی این وبسایت متعلق به WONMOV میباشد.</span>
                </div>
            </div>
        </footer>
        <MobileMenu />
        </>
    );
}
